import { useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import { Poster } from "@/components/Poster";

export default function PosterPage() {
  const [params] = useSearchParams();
  const place = (params.get("place") || "").slice(0, 40);
  useEffect(() => {
    document.title = `Comfort Taxi poster${place ? ` · ${place}` : ""}`;
  }, [place]);
  return (
    <div className="min-h-screen bg-slate-200 py-8 print:bg-white print:py-0">
      <style>{"@page { size: A4 portrait; margin: 0; }"}</style>
      <div className="mx-auto mb-4 flex max-w-[794px] items-center justify-between px-4 print:hidden">
        <Link to="/" data-testid="poster-back-link" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 hover:text-blue-700"><ArrowLeft className="h-4 w-4" /> Back</Link>
        <button data-testid="poster-page-print-button" onClick={() => window.print()} className="inline-flex items-center gap-2 rounded-full bg-blue-700 px-5 py-2.5 text-sm font-semibold text-white hover:bg-blue-600">
          <Printer className="h-4 w-4" /> Print poster
        </button>
      </div>
      <div className="px-4 print:px-0"><Poster place={place} /></div>
    </div>
  );
}
